import {
  Modal,
  Skeleton,
  Form,
  Input,
  Radio,
  RadioChangeEvent,
  DatePicker,
} from "antd";
import dayjs from "dayjs";
import "dayjs/locale/pt-br"; // Caso queira suportar o formato em português
import customParseFormat from "dayjs/plugin/customParseFormat";

import { formStyle, layout, formStyleRepresentante } from "../styles";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useError } from "../../../uteis/mensagens/useError";
import { useSuccess } from "../../../uteis/mensagens/useSuccess";
import { useRepresentante } from "../hooks/useRepresentante";
import { useAtualizarRepresentante } from "../hooks/useAtualizarRepresentante";
import { Usuario } from "../../../interfaces/Usuario";
import { useUsuario } from "../hooks/useUsuario";

import PhoneInput from "react-phone-input-2";

export default function ModalEditar({
  isModalOpen,
  handleFechar,
  usuarioId,
  representanteId,
}: any) {
  dayjs.extend(customParseFormat);
  const [representanteForm] = Form.useForm();
  const [usuarioForm] = Form.useForm();
  // UseStates necessários
  const [check, setCheck] = useState<number>();
  const [active, setActive] = useState<number>();
  const [phone, setPhone] = useState("");

  // Estado inicial de Representante
  const [representanteData, setRepresentanteData] = useState<any>({});

  // Estado inicial de Usuario
  const [usuarioData, setUsuarioData] = useState<Usuario>({});

  const { representante, isLoading } = useRepresentante(representanteId);
  const { usuario, isLoading: isLoadingUsuario } = useUsuario(
    isModalOpen,
    usuarioId
  );

  const handlePhoneChange = (value: string) => {
    setPhone(value);
  };

  

  // Função que armazena o dado selecionado de checkado
  const checkChange = (e: RadioChangeEvent) => {
    setCheck(e.target.value);
  };

  const usuarioChange = (changedValues: Partial<any>, allValues: any) => {
    setUsuarioData(allValues);
  };
  const representanteChange = (changedValues: Partial<any>, allValues: any) => {
    setRepresentanteData(allValues);
  };

  const {
    atualizarRepre,
    isLoading: isLoadingAtualizar,
    error,
    success,
    resetError,
  } = useAtualizarRepresentante();

  // Atualiza o estado do formulário somente quando todos os dados estiverem disponíveis
  useEffect(() => {
    if (isModalOpen) {
      if (representante && usuario) {
        // Atualiza os dados do formulário com as informações do representante
        setUsuarioData({
          nome: usuario?.nome,
          sobrenome: usuario?.sobrenome,
          email: usuario?.email,
          celular: usuario?.celular,
        });
        setRepresentanteData({
          created_at: representante?.created_at,
          dataAssinatura: representante?.dataAssinatura,
          dataVencimento: representante?.dataVencimento,
          checked: representante?.checked,
          active: representante?.active,
        });
      }
    }
  }, [isModalOpen, representante, usuario]);

  // Usar setFieldsValue quando o cadastroInicial mudar
  useEffect(() => {
    if (!representanteForm && usuarioForm) {
      return;
    }
    usuarioForm.setFieldsValue({
      nome: usuarioData.nome,
      sobrenome: usuarioData.sobrenome,
      email: usuarioData.email,
      celular: usuarioData.celular,
    });
    representanteForm.setFieldsValue({
      created_at: representanteData.created_at
        ? dayjs(representanteData.created_at)
        : null,
      dataAssinatura: representanteData.dataAssinatura
        ? dayjs(representanteData.dataAssinatura)
        : null,
      dataVencimento: representanteData.dataVencimento
        ? dayjs(representanteData.dataVencimento)
        : null,
      checked: representanteData.checked,
      active: representanteData.active,
    });
  }, [usuarioForm, representanteForm, usuarioData, representanteData]);

  // Exibe a Mensagem de  Erro
  const { showError, contextHolder: errorContextHolder } = useError();

  // Exibe a Mensagem de  Erro
  const { showSuccess, contextHolder: successContextHolder } = useSuccess();

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  // Hook de navegação do React Router
  const navigate = useNavigate();
  useEffect(() => {
    if (isModalOpen && success && !successDisplayed) {
      // Mensagem de sucesso
      const msgSuccess = "Representante atualizado com Sucesso!";
      showSuccess(msgSuccess);
      setSuccessDisplayed(true);

      // Limpa sucesso após 3 segundos
      setTimeout(() => {
        navigate(0);
      }, 2000);
    }

    if (isModalOpen && error && !errorDisplayed) {
      // Mensagem de erro
      let msgError = "Não foi possível atualizar o representante!";
      showError(msgError);
      setErrorDisplayed(true);

      // Limpa erro após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }

    // Reset quando o modal fecha
    if (!isModalOpen) {
      setSuccessDisplayed(false);
      setErrorDisplayed(false);
    }
  }, [
    isModalOpen,
    success,
    error,
    showSuccess,
    showError,
    successDisplayed,
    errorDisplayed,
    navigate,
    resetError,
  ]);

  return (
    <>
      <Modal
        open={isModalOpen}
        cancelText="Cancelar"
        okText="Atualizar"
        onOk={() =>
          atualizarRepre(
            representante.id,
            representanteData,
            representante.usuarioId,
            usuarioData
          )
        }
        confirmLoading={isLoadingAtualizar}
        onCancel={handleFechar}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          }, // Botão "Ativar" com fundo verde
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          }, // Botão "Cancelar" com fundo vermelho
        }}
      >
        {isLoading && isLoadingUsuario && <Skeleton active />}
        {!isLoading && !isLoadingUsuario && (
          <>
            <>{errorContextHolder}</>
            <>{successContextHolder}</>
            <Form
              {...layout}
              form={usuarioForm}
              initialValues={usuarioData}
              onValuesChange={(changedValues, allValues) =>
                usuarioChange(changedValues, allValues)
              }
              name="representante-usuario"
              style={formStyle}
            >
              <h1 style={{ margin: 10 }}>Representante</h1>
              <Form.Item name={["nome"]} label="Nome " className="formItems">
                <Input />
              </Form.Item>
              <Form.Item
                name={["sobrenome"]}
                label="Sobrenome "
                className="formItems"
              >
                <Input />
              </Form.Item>

              <Form.Item name={["email"]} label="Email " className="formItems">
                <Input />
              </Form.Item>

              <Form.Item
                name="celular"
                label="Celular"
                className="formItems"
                getValueFromEvent={(value) => value} // Garante que o valor do PhoneInput seja capturado corretamente
              >
                <PhoneInput
                  country={"br"}
                  value={phone}
                  onChange={handlePhoneChange}
                  placeholder="Digite seu telefone"
                  inputClass="phone-input"
                />
              </Form.Item>
            </Form>
            <Form
              {...layout}
              form={representanteForm}
              initialValues={representanteData}
              onValuesChange={(changedValues, allValues) =>
                representanteChange(changedValues, allValues)
              }
              name="representante"
              style={formStyleRepresentante}
            >
              <Form.Item
                name={["created_at"]}
                label="Data inclusão "
                className="formItems"
              >
                <DatePicker format="DD/MM/YYYY" readOnly />
              </Form.Item>

              <Form.Item
                name={["dataAssinatura"]}
                label="Data assinatura "
                className="formItems"
              >
                <DatePicker format="DD/MM/YYYY" />
              </Form.Item>
              <Form.Item
                name={["dataVencimento"]}
                label="Data vencimento "
                className="formItems"
              >
                <DatePicker format="DD/MM/YYYY" />
              </Form.Item>
              <Form.Item
                name={["checked"]}
                label="Valido "
                className="formItems"
              >
                <Radio.Group onChange={checkChange} value={check}>
                  <Radio value={0}>Não</Radio>
                  <Radio value={1}>Sim</Radio>
                </Radio.Group>
              </Form.Item>
            </Form>
          </>
        )}
      </Modal>
    </>
  );
}
